import b1img from "../../assets/industries/b1img.png"
import b2img from "../../assets/industries/b2img.png"
import b3img from "../../assets/industries/b3img.png"
import b4img from "../../assets/industries/b4img.png"
import b5img from "../../assets/industries/b5img.png"
import b6img from "../../assets/industries/b6img.png"

export const bannersData = [
  {
    id: "banner-1",
    className: "banner-1 flex-lg-row flex-column",
    title: "Get unmatched ecommerce expertise",
    description: "We've worked with hundreds of online businesses and understand the intricacies of ecommerce bookkeeping like no one else.",
    image: b1img,
    tdClass: "col-lg-6 col",
    imgClass: "col-lg-6 col",
  },
  {
    id: "banner-2",
    className: "banner-2 col-12 col-lg justify-content-between",
    title: "Confidently move into the future",
    description: "No matter how your needs evolve, we've got you covered. Whether you're expanding into omni-channel strategies or launching new product lines.",
    image: b2img,
    tdClass: " ",
    imgClass: "",
  },
  {
    id: "banner-3",
    className: " banner-2 col-12 col-lg",
    title: "Impress investors with sleek financial models",
    description: "Our meticulous bookkeeping sets the stage for our CFOs to strategically analyze your business.",
    image: b3img,
    tdClass: " ",
    imgClass: "",
  },
  {
    id: "banner-4",
    className: "banner-4 flex-lg-row-reverse flex-column",
    title: "Know and grow your sales",
    description: "We help you effectively manage and optimize your business by accurately reporting on gross sales, net sales, COGS, and inventory.",
    image: b4img,
    tdClass: "col-lg-6 col-12",
    imgClass: "col-lg-6 col-12",
  },
  {
    id: "banner-5",
    className: "banner-2 col-12 col-lg justify-content-between",
    title: "Know and grow your sales",
    description: "We help you effectively manage and optimize your business by accurately reporting on gross sales, net sales, COGS, and inventory.",
    image: b5img,
    tdClass: "",
    imgClass: "",
  },
  {
    id: "banner-6",
    className: "banner-2 col-12 col-lg",
    title: "Know and grow your sales",
    description: "We help you effectively manage and optimize your business by accurately reporting on gross sales, net sales, COGS, and inventory.",
    image: b6img,
    tdClass: "",
    imgClass: "",
  }

];
